import { createApiEffect } from '@/features/api/common/create-api-effect'
import { StudyYear } from '@/features/api/subject/types'

export const getUserStudyYearFx = createApiEffect<number, StudyYear>({
  requestMapper: (id) => ({
    method: 'GET',
    url: `/api/user-app/study-year/${id}/`,
  }),
})
